// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import MeScroll from 'mescroll.js'
// import 'mescroll.js/mescroll.min.css'
import Cookies from 'js-cookie'
import  VueResource  from 'vue-resource'
import VueTouch from 'vue-touch'
import ElementUI from 'element-ui'
import VueCropper from 'vue-cropper'

import 'element-ui/lib/theme-chalk/index.css'
import '../static/css/el-box.css'

import locale from 'element-ui/lib/locale/lang/en' // lang i18n

import './components/toast/toast.css';
import Toast from './components/toast/index';

import Swiper from 'swiper';
import './components/swiper/dist/css/swiper.min.css';

import common from '../src/components/common.js';
import city from '../src/utils/city.js';

import Global from './utils/book_global'
import userTool from './utils/user'
import Vconsole from 'vconsole'
Vue.use(VueCropper)

Vue.prototype.GLOBAL = Global //挂载到Vue实例上面

Vue.prototype.common = common;

Vue.prototype.userTool = userTool;

Vue.prototype.$city = city;

Vue.use(Toast);

Vue.use(VueResource);
// Vue.use(VueTouch, {name: 'v-touch'})
Vue.use(ElementUI, { locale })

Vue.config.productionTip = false

//弹出框禁止滑动
Vue.prototype.stopScroll = function () {
  var mo = function (e) { e.preventDefault() }
  document.body.style.overflow = 'hidden'
  document.addEventListener('touchmove', mo, false)// 禁止页面滑动
}

//弹出框可以滑动
Vue.prototype.canScroll = function () {
  var mo = function (e) {
    e.preventDefault()
  }
  document.body.style.overflow = ''// 出现滚动条
  document.removeEventListener('touchmove', mo, false)
}

// new Vconsole()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js